import { LogOut, Building2 } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ClientLogo from "./ClientLogo";
import { Button } from "./ui/button";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const homePath = user?.role === "admin" ? "/admin" : "/responsabile";

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <button
            onClick={() => navigate(homePath)}
            className="flex items-center gap-3 group"
            data-testid="header-logo-button"
          >
            <ClientLogo client={user?.client} className="h-10 w-10 ring-1 ring-slate-200 group-hover:ring-blue-300 transition text-sm" testId="header-client-logo" />
            <div className="hidden sm:block text-left">
              <div className="font-display font-bold text-slate-900 leading-none tracking-tight" data-testid="header-client-title">{user?.client?.title || "Dance Analysis"}</div>
              <div className="text-[11px] text-slate-500 uppercase tracking-[0.18em] mt-1" data-testid="header-client-name">{user?.client?.name}</div>
            </div>
          </button>

          <div className="flex items-center gap-3">
            {user && (
              <div className="hidden sm:flex flex-col items-end leading-tight">
                <span className="font-medium text-slate-900 text-sm" data-testid="header-user-name">{user.name}</span>
                <span className="text-[11px] uppercase tracking-wider text-blue-700 font-semibold" data-testid="header-user-role">
                  {user.role === "admin" ? "Amministratore" : "Responsabile"}
                </span>
              </div>
            )}
            {user?.role === "admin" && (
              <Button variant="outline" size="sm" onClick={() => navigate("/superadmin")} data-testid="header-clients-button" className="border-slate-300">
                <Building2 className="h-4 w-4 sm:mr-2" /><span className="hidden sm:inline">Clienti</span>
              </Button>
            )}
            <Button
              variant="outline"
              size="sm"
              onClick={logout}
              data-testid="header-logout-button"
              className="border-slate-300 hover:border-rose-300 hover:text-rose-600 hover:bg-rose-50"
            >
              <LogOut className="h-4 w-4 mr-2" />
              Esci
            </Button>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        {children}
      </main>

      <footer className="mt-auto border-t border-slate-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-center">
          <p className="text-sm text-slate-500" data-testid="footer-credit">
            Sviluppato da <span className="font-semibold text-slate-700">LMKT</span> — Simone Arrighi &amp; Valeria Tria
          </p>
        </div>
      </footer>
    </div>
  );
}
